<template>
  <d-card class="card-small">
    <div
      v-if="!loaded"
      class="overlay-loading">
      <h2 class="preloader isLoading">Trwa ładowanie</h2>
    </div>
    <ExpenseTableHeader
      v-model="filters"
      :filters="filters"
      :users="allUsers"
      :cost-types="allCostTypes"
      @filter="filterList"
      @clear="clearFilters"
    />
    <ExpenseTableBody 
      :expenses="expenses"
      :pagination-meta-data="paginationMetaData"
      :current-page="currentPage"
      :lang="lang"
      :action-in-progress="actionInProgress"
    >
      <template v-slot:action="slotProps">
        <d-button
          @click.prevent="editExpense(slotProps.expense)"
          class="mr-2 mt-1 mb-1 ml-2"
          :disabled="actionInProgress"
        >
          <i class="material-icons">edit</i> Edit
        </d-button>
        <d-button
          theme="danger"
          class="mr-2 mt-1 mb-1 ml-2"
          :disabled="actionInProgress"
          @click.prevent="removeExpense(slotProps.expense)"
        >
          <i class="material-icons">delete</i> Delete
        </d-button>
      </template>
    </ExpenseTableBody>
  </d-card>
</template>

<script>
import HasFilters from '@/mixins/HasFilters.vue';
import HasPagination from '@/mixins/HasPagination.vue';
import ListUtils from '@/utils/ListUtils.js';
import { mapGetters, mapActions } from 'vuex'
import ExpenseTableHeader from '@/components/expense/list/molecules/ExpenseTableHeader.vue';
import ExpenseTableBody from '@/components/expense/list/molecules/ExpenseTableBody.vue';

export default {
  name: 'ExpensesTable',
  mixins: [HasFilters, HasPagination],
  components: {
    ExpenseTableHeader,
    ExpenseTableBody
},
  methods: {
    ...mapActions([
      'getAllUsers',
      'getAllCostTypes',
    ]),
    clearFilters () {
      Vue.set(this, 'loaded', false);
      Vue.set(this, 'loadError', false);
      Vue.set(this, 'filters', {
        user_id: '',
        expenses_cost_type: '',
        search: '',
        cash_refunded: '',
        transfer_complete: ''
      });
      this.filters = {
        user_id: '',
        expenses_cost_type: '',
        search: '',
        cash_refunded: '',
        transfer_complete: ''
      };

      this.$bus.$emit('view-filters-reset');
      this.$bus.$emit('pagination-reset');
    },
    filterList () {
      Vue.set(this, 'loaded', false);
      Vue.set(this, 'loadError', false);
      this.$bus.$emit('pagination-reset');
      this.$bus.$emit('view-filters-save');
    },
    debouncedLoadFilteredData: _.debounce(function () {
      Vue.set(this, 'loaded', false);
      Vue.set(this, 'loadError', false);
      this.loadItemsData();
    }, 500),  
    loadItemsData () {
      ListUtils.loadItemsData(this, {
        method: 'post',
        endpoint: '/api/expenses/items',
        listField: 'expenses',
        pagination: true,
        params: {
          page: this.currentPage,
          where: this.filters,
          short: true
        }
      });
    },
    editExpense (expense) {
      this.$router.push({name: 'expense-edit', params: {id: expense.id}})
    },
    removeExpense (expense) {
      this.actionInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/api/expenses/delete/' + expense.id,
        id: null,
        successTitle: 'Wydatek został usunięty',
        successText: '',
        confirmTitle: 'Uwaga',
        confirmText: 'Czy potwierdzasz usunięcie wydatku?',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie wydatku nie powiodło się. Spróbuj ponownie.',
        confirmButtonText: 'Tak',
        cancelButtonText: 'Nie',
        successAction: () => {
          this.actionInProgress = false;
          this.debouncedLoadFilteredData();
        },
        failAction: () => {
          this.actionInProgress = false;
        },
        cancelAction: () => {
          this.actionInProgress = false;
        },
      });
    }, 
  },
  computed: {
    ...mapGetters([
      'allUsers',
      'allCostTypes',
    ]),
  },
  mounted () {
    this.loadItemsData();
    this.getAllUsers();
    this.getAllCostTypes()
  },
  data(){
    return {
      actionInProgress: false,
      filters: {
        cash_refunded: '',
        expenses_cost_type: '',
        search: '',
        transfer_complete: '',
        user_id: ''
      },
      lang: {
        cash: 'Gotówka',
        transfer: 'Przelew'
      },
      loaded: false,
      loadError: false,
      expenses: [],
      current_page: 1,
      last_page: 1,
    }
  }
}
</script>
